import React from 'react';
import { Link } from 'react-router-dom';
import { AddClientBox } from './AddClientBox';
import { EditClientsBox } from './EditClientsBox';
import DeleteClientDialog from './DeleteClientDialog';
import './clientsPage.css';

export default function ClientsPage({
  isAdmin,
  addClient,
  clientList,
  loadClients,
  setClientToDeleteID,
  setClientToDeleteName,
  displayDeleteClientDialog,
  setDisplayDeleteClientDialog,
  clientToDeleteName,
  clientToDeleteID,
  clientMasterList,
  deactivatedClientsList,
  restoreClient,
  displayDeactivatedClientsDialog,
  setDisplayDeactivatedClientsDialog,
}) {
  const activeClients = (clientList ?? []).sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="clientsPageDiv">
      <div className="clientsPageHeader">
        <Link to="/" className="backToHomeLink">← Back to Home</Link>
        <h2 className="clientsPageTitle">Clients</h2>
      </div>

      <div className="formSep"></div>

      {!isAdmin && (
        <ul className="clientsSimpleList">
          {activeClients.map(c => (
            <li key={c.docID}>
              <Link to={`/client/${encodeURIComponent(c.name)}`} className="clientsSimpleLink">
                {c.name}
              </Link>
            </li>
          ))}
        </ul>
      )}

      {isAdmin && (
        <>
          <AddClientBox addClient={addClient} />
          <div className="formSep"></div>
          <EditClientsBox
            clientList={clientList}
            InitialLoadClients={loadClients}
            setClientToDeleteID={setClientToDeleteID}
            setClientToDeleteName={setClientToDeleteName}
            setDisplayDeleteClientDialog={setDisplayDeleteClientDialog}
            clientMasterList={clientMasterList}
            displayDeactivatedClientsDialog={displayDeactivatedClientsDialog}
            setDisplayDeactivatedClientsDialog={setDisplayDeactivatedClientsDialog}
            deactivatedClientsList={deactivatedClientsList}
            restoreClient={restoreClient}
          />
          <DeleteClientDialog
            displayDeleteClientDialog={displayDeleteClientDialog}
            setDisplayDeleteClientDialog={setDisplayDeleteClientDialog}
            InitialLoadClients={loadClients}
            setClientToDeleteName={setClientToDeleteName}
            clientToDeleteName={clientToDeleteName}
            setClientToDeleteID={setClientToDeleteID}
            clientToDeleteID={clientToDeleteID}
          />
        </>
      )}
    </div>
  );
}
